import { Response } from '../types/response';
import { Resource } from '../types/resource';

/**
 * Type guard to check if a Response is successful (not an Error)
 */
export function isSuccess<T>(response: Response<T>): response is T {
  return !(response instanceof Error);
}

/**
 * Type guard to check if a Response is an error
 */
export function isError<T>(response: Response<T>): response is Error {
  return response instanceof Error;
}

/**
 * Convert a Response to a Resource
 */
export function toResource<T>(response: Response<T>): Resource<T> {
  if (isError(response)) {
    return { error: response };
  }
  return response;
}

/**
 * Convert an Error to a Resource with error state
 */
export function toResourceError<T>(error: Error): Resource<T> {
  return { error };
}

/**
 * Type guard to check if a Resource is loaded (has data, not loading or error)
 */
export function isLoaded<T>(resource: Resource<T>): resource is T {
  if (resource === undefined) {
    return false;
  }
  // Check if it's an error object
  if (typeof resource === 'object' && resource !== null && 'error' in resource) {
    return false;
  }
  return true;
}

/**
 * Type guard to check if a Resource has an error
 */
export function hasError<T>(resource: Resource<T>): resource is { error: Error } {
  return typeof resource === 'object' && resource !== null && 'error' in resource;
}
